import LockScroll from '@/utils/lockScroll';

export default (() => {
	let _$toggle;
	let _isOpen = false;

	function init(toggle) {
		_$toggle = toggle;
		_$toggle.on('click', toggleNav);
	}

	function toggleNav(e) {
		if (_isOpen) {
			$('body').removeClass('menu-is-open');
			LockScroll.unlock();
			$(e.currentTarget).removeClass('is-active');
			_isOpen = false;
		} else {
			$(e.currentTarget).addClass('is-active');
			$('body').addClass('menu-is-open');
			LockScroll.lock();
			_isOpen = true;
		}
	}

	return {
		init
	};
})();